/* ============================================================
   Q — Complete your set (cross-sell)

   Por qué existe: las unidades por pedido cayeron de 2.5 a 1.3
   mientras el precio unitario subía. La gente compra UNA pieza.
   Esto ofrece el complemento correcto sin sacarla de la página.

   Cómo elige qué mostrar:
   1. Saca el ESTAMPADO del título ("Star Crossed Mesh Bag" →
      "Star Crossed") y busca accesorios del mismo estampado con
      la API de búsqueda de Shopify. Es el match fuerte: set a juego.
   2. Si no hay match de estampado, cae a accesorios generales.
   Nunca muestra el producto que ya estás viendo ni lo que ya
   está en el carrito.
   ============================================================ */

(function () {
  'use strict';

  // Categorías que SÍ son complemento de un traje. El match es por título
  // porque suggest.json no devuelve product_type de forma confiable.
  var ACCESORIOS = [
    { etiqueta: 'mesh bag', prueba: /\bmesh bag\b/i },
    { etiqueta: 'towel', prueba: /\btowel\b/i },
    { etiqueta: 'cap', prueba: /\b(cap|swimming cap)\b/i },
    { etiqueta: 'facemask', prueba: /\bfacemask\b/i },
  ];

  // Palabras de categoría que se recortan del final del título para
  // quedarse con el estampado.
  var CATEGORIAS = [
    'quick dry towel', 'silicon swimming cap', 'silicone swimming cap',
    'swimming cap', 'silicone cap', 'silicon cap', 'mesh drag swimsuit',
    'classic sports bikini top', 'tieback bikini bottom', 'tieback bikini top',
    'bandeau bikini bottom', 'bandeau bikini top', 'demi tieback bikini top',
    'ciara tieback bikini top', 'high hip one piece swimsuit',
    'tieback one piece swimsuit', 'surf swimsuit classic', 'female waterpolo',
    'waterpolo brief swimwear', 'waterpolo brief swimsuit', 'waterpolo brief',
    'skinny strap swimsuit', 'classic strap swimsuit', 'classic brief swimsuit',
    'sunback tank swimsuit', 'atlas jammer swimsuit', 'jammer swimsuit',
    'drag suit', 'mesh bag', 'facemask', 'towel', 'waterpolo',
    'classic brief', 'classic strap', 'skinny strap', 'sunback tank',
    'jammer', 'swimsuit', 'swimwear', 'cap',
  ];

  var MAX = 3;

  // La pareja obvia: si ves un top, lo que falta es el bottom a juego (y al revés).
  // Es el match más fuerte de todos, va antes que cualquier accesorio.
  var ES_TOP = /\b(bikini top|demi|ciara)\b/i;
  var ES_BOTTOM = /\bbikini bottom\b/i;

  function complementoDirecto(tituloActual) {
    if (ES_TOP.test(tituloActual)) return ES_BOTTOM;
    if (ES_BOTTOM.test(tituloActual)) return ES_TOP;
    return null;
  }

  function estampado(titulo) {
    if (!titulo) return '';
    var t = String(titulo).trim();
    // "Tie Dye Blue - High Hip One Piece Swimsuit" → "Tie Dye Blue"
    if (t.indexOf(' - ') > -1) return t.split(' - ')[0].trim();
    var bajo = t.toLowerCase();
    for (var i = 0; i < CATEGORIAS.length; i++) {
      var cat = CATEGORIAS[i];
      if (bajo.length > cat.length && bajo.slice(-cat.length) === cat) {
        return t.slice(0, t.length - cat.length).trim().replace(/[-–—,]$/, '').trim();
      }
    }
    return t;
  }

  function esAccesorio(titulo) {
    for (var i = 0; i < ACCESORIOS.length; i++) {
      if (ACCESORIOS[i].prueba.test(titulo)) return true;
    }
    return false;
  }

  function dinero(centavos) {
    try {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(centavos, window.Shopify.money_format);
      }
    } catch (e) { /* cae al formato simple */ }
    return '$' + (centavos / 100).toFixed(2);
  }

  function buscar(termino, limite) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(termino) +
      '&resources[type]=product&resources[limit]=' + (limite || 10) +
      '&resources[options][unavailable_products]=hide';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.resources || !j.resources.results) return [];
        return j.resources.results.products || [];
      })
      .catch(function () { return []; });
  }

  class QCrossSell extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      this.lista = this.querySelector('.qxs__list');
      this.excluir = (this.dataset.exclude || '')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      this.cargar();
    }

    async cargar() {
      var semilla = this.dataset.seed || '';
      var print = estampado(semilla);
      var candidatos = [];

      if (print && print.length > 2) {
        var mismoPrint = await buscar(print, 10);

        // 1º la pareja a juego (top ↔ bottom del mismo estampado).
        var pareja = complementoDirecto(semilla);
        if (pareja) {
          candidatos = mismoPrint.filter(function (p) { return pareja.test(p.title); });
        }

        // 2º accesorios del mismo estampado (mesh bag, towel, cap).
        var yaEsta = {};
        candidatos.forEach(function (p) { yaEsta[p.handle] = true; });
        mismoPrint.forEach(function (p) {
          if (!yaEsta[p.handle] && esAccesorio(p.title)) {
            yaEsta[p.handle] = true;
            candidatos.push(p);
          }
        });

        // 3º el MISMO estampado en otros cortes (jammer, classic brief, skinny
        // strap…). Antes se saltaba este paso y se iba directo a accesorios
        // genéricos, por eso salían siempre Maryland y Mermaid Cosmo en todas
        // las fichas. Esto siempre es relevante y siempre cambia por producto.
        var self1 = this;
        mismoPrint.forEach(function (p) {
          if (candidatos.length >= MAX) return;
          if (yaEsta[p.handle]) return;
          if (self1.excluir.indexOf(p.handle) > -1) return;
          yaEsta[p.handle] = true;
          candidatos.push(p);
        });
      }

      // 4º último recurso: accesorios generales. Se busca cada término POR
      // SEPARADO (Shopify no devuelve nada con "mesh bag towel cap" junto) y se
      // ROTA la elección según el producto, para no repetir siempre el mismo.
      if (candidatos.length < MAX) {
        var vistos = {};
        candidatos.forEach(function (p) { vistos[p.handle] = p; });
        var giro = 0;
        for (var i = 0; i < semilla.length; i++) giro = (giro + semilla.charCodeAt(i)) % 97;
        var terminos = ['mesh bag', 'towel', 'swimming cap'];
        for (var t = 0; t < terminos.length && Object.keys(vistos).length < MAX; t++) {
          var extra = (await buscar(terminos[t], 8)).filter(function (p) {
            return esAccesorio(p.title) && !vistos[p.handle];
          });
          if (extra.length) vistos[extra[(giro + t) % extra.length].handle] = extra[(giro + t) % extra.length];
        }
        candidatos = Object.keys(vistos).map(function (k) { return vistos[k]; });
      }

      var self = this;
      candidatos = candidatos.filter(function (p) {
        return self.excluir.indexOf(p.handle) === -1;
      }).slice(0, MAX);

      if (!candidatos.length) { this.hidden = true; return; }
      this.pintar(candidatos);
    }

    pintar(items) {
      var html = items.map(function (p) {
        var precio = typeof p.price === 'number'
          ? dinero(p.price)
          : (p.price ? String(p.price) : '');
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        return '' +
          '<li class="qxs__item">' +
            '<a class="qxs__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
              (img ? '<img src="' + img + '&width=300" alt="" loading="lazy" width="300" height="300">' : '') +
            '</a>' +
            '<a class="qxs__name" href="' + p.url + '">' + p.title + '</a>' +
            '<p class="qxs__price">' + precio + '</p>' +
            '<button type="button" class="qxs__add" data-handle="' + p.handle + '" data-url="' + p.url + '">Add</button>' +
          '</li>';
      }).join('');

      this.lista.innerHTML = html;
      this.hidden = false;
      this.lista.addEventListener('click', this.alHacerClic.bind(this));
    }

    async alHacerClic(evento) {
      var boton = evento.target.closest('.qxs__add');
      if (!boton || boton.disabled) return;
      evento.preventDefault();
      boton.disabled = true;
      var textoOriginal = boton.textContent;
      boton.textContent = 'Adding';

      try {
        var producto = await fetch('/products/' + boton.dataset.handle + '.js')
          .then(function (r) { return r.json(); });
        var disponibles = (producto.variants || []).filter(function (v) { return v.available; });

        // Con varias tallas/colores no adivinamos: la mandamos a elegir.
        if (disponibles.length !== 1) {
          window.location.href = boton.dataset.url;
          return;
        }

        await this.agregar(disponibles[0].id);
        boton.textContent = 'Added';
        boton.dataset.state = 'done';
      } catch (e) {
        boton.textContent = textoOriginal;
        boton.disabled = false;
      }
    }

    async agregar(idVariante) {
      var drawer = document.querySelector('cart-drawer');
      var cuerpo = { items: [{ id: idVariante, quantity: 1 }] };

      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        cuerpo.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        cuerpo.sections_url = window.location.pathname;
      }

      var estado = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(cuerpo),
      }).then(function (r) { return r.json(); });

      if (estado.status) throw new Error(estado.description || 'cart error');

      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(estado);
        if (typeof drawer.open === 'function') drawer.open();
      } else {
        document.dispatchEvent(new CustomEvent('q:cart:updated'));
      }
    }
  }

  if (!customElements.get('q-cross-sell')) {
    customElements.define('q-cross-sell', QCrossSell);
  }
})();
